export default "__VITE_ASSET__hjA2cW5S__"